var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "el-table",
        { attrs: { data: _vm.schema.values, stripe: "stripe" } },
        [
          _c("el-table-column", {
            attrs: { formatter: _vm.formattedMarcos, label: "Marcos" }
          }),
          _c("el-table-column", {
            attrs: { label: "Distância (m)", prop: "distancia" }
          }),
          _c("el-table-column", {
            attrs: { label: "Azimutes", prop: "azimute" }
          }),
          _c("el-table-column", {
            attrs: { prop: "confinante", label: "Confinantes" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-580d4eec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-580d4eec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppListagemLimites.vue
// module id = null
// module chunks = 